var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDankort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 19,
    viewBox: "0 0 66 41",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1061.000000, -1396.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(611.000000, 1396.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(450.000000, 0.512195)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.002959, 0.122027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8572603,0.395342466 C9.1260274,0.395342466 0.395205479,9.12479452 0.395205479,19.8546575 C0.395205479,30.5856164 9.1260274,39.3158904 19.8572603,39.3158904 L46.0671233,39.3158904 C56.7969863,39.3158904 65.5265753,30.5856164 65.5265753,19.8546575 C65.5265753,9.12479452 56.7969863,0.395342466 46.0671233,0.395342466 L19.8572603,0.395342466 Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9514658,9.3729726 L7.56310959,9.3729726 C10.5303699,5.89927397 14.9405068,3.69310959 19.8572192,3.69310959 L46.0670822,3.69310959 C50.9820137,3.69310959 55.3913288,5.89927397 58.3584521,9.37215068 L44.718863,9.37215068 L37.869,16.5128356 C37.3642055,11.029 32.4600959,9.3729726 25.9514658,9.3729726 Z M50.6488082,18.6664247 L59.0555205,10.2479315 C61.0485342,12.9351918 62.2296301,16.2598493 62.2296301,19.8547808 C62.2296301,23.2609452 61.1694932,26.423 59.3644247,29.0316301 L50.6488082,18.6664247 Z M15.2276849,16.2860959 L23.6894658,16.2860959 C25.5839863,16.2860959 27.1261781,17.1340411 26.5122055,19.3193836 C25.8917945,21.5288356 25.0530274,22.6765068 22.2808356,22.6765068 L12.9034384,22.6765068 L15.2276849,16.2860959 Z M44.7757808,29.9041233 L58.7170137,29.9041233 C55.7533151,33.6279589 51.184274,36.0190548 46.0671507,36.0190548 L19.8571507,36.0190548 C14.7382466,36.0190548 10.1682466,33.627 7.20468493,29.9030274 L23.5864658,29.9030274 C31.8063288,29.9030274 36.1911233,26.9909726 37.5312603,20.7486438 L44.7757808,29.9041233 Z",
    fill: "#474747"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDankort);
export default __webpack_public_path__ + "static/media/dankort.877a52ab7a58d517457d7db8b207e0af.svg";
export { ForwardRef as ReactComponent };